import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Experiences } from "./components/Experiences";
import { Projects } from "./components/Projects";

import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Experiences />
      <Projects />
      <Footer />
    </div>
  );
}

export default App;
